module.exports = __webpack_public_path__ + "media/img/android-icon-36x36-fe4b09a12fb898e3ffb85fb33a69c7c3.png";